import { ActionContext } from 'vuex';

import api from '@/api';
import { ApiDeviceActions, ApiDeviceActionsItem, ApiDeviceListItem } from '@/api/types/device';

interface FencesState {
    list: ApiDeviceActions;
    listRequestPending: boolean;
}

const fences = {
    namespaced: true,
    state: {
        list: {},
        listRequestPending: false,
    },
    getters: {
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
        deviceFences(state: FencesState, getters: any, rootState: any) {
            return (deviceActive: number | null): Array<ApiDeviceActionsItem> => {
                let fencesIn: Array<number> | unknown = [];
                let fencesOut: Array<number> | unknown = [];
                let fences: Array<ApiDeviceActionsItem> = [];

                if (!deviceActive) {
                    return [];
                }
                const device = rootState.device?.list?.List?.find((d: ApiDeviceListItem) => d.Id === deviceActive);

                if (!device || !state.list) {
                    fences = [];
                } else {
                    if (typeof device.GeofIn === 'undefined' || !device.GeofIn || device.GeofIn.length === 0) {
                        fencesIn = [];
                    } else {
                        fencesIn = state.list.List?.filter((f) => device.GeofIn.includes(f.Id));
                    }

                    if (typeof device.GeofOut === 'undefined' || !device.GeofOut || device.GeofOut.length === 0) {
                        fencesOut = [];
                    } else {
                        fencesOut = state.list.List?.filter((f) => device.GeofOut.includes(f.Id));
                    }
                    fences =
                        [...(fencesIn as Array<ApiDeviceActionsItem>), ...(fencesOut as Array<ApiDeviceActionsItem>)] ||
                        [];
                }

                return fences || [];
            };
        },
    },
    mutations: {
        startListRequest(state: FencesState): void {
            state.listRequestPending = true;
        },
        endListRequest(state: FencesState): void {
            state.listRequestPending = false;
        },
        updateList(state: FencesState, list: ApiDeviceActions): void {
            state.list = list;
        },
        clearList(state: FencesState): void {
            state.list = {};
        },
    },
    actions: {
        clearList(context: ActionContext<FencesState, null>): void {
            context.commit('clearList');
        },
        async list(context: ActionContext<FencesState, null>): Promise<void> {
            context.commit('startListRequest');
            try {
                const token = window.localStorage.getItem('authcredentials');
                const response = await api.device.fences(token || '');
                context.commit('updateList', response.data);
            } catch (err) {
                // console.log(err);
            } finally {
                context.commit('endListRequest');
            }
        },
    },
};

export default fences;
